export const ROWS_PER_PAGE = 20;
export const ROWS_PER_PAGE_OPTIONS = [20, 50, 100, 500];
export const TABS = {
    LIVE: 0,
    WATCHLIST: 1,
    ERROR: 2,
    HOME: 3,
    FAVOURITES: 4,
    CONFIGURATOR: 8,
    SLA: 5,
    REPORTING: 6,
    ADMIN: 7,
};

export const JOBLISTACTION = {
    PLAY: 'Play',
    PAUSE: 'Pause',
    BAN: 'Ban',
    DEFAULT: 'Feature not licensed',
};

export const HEADERREPORTWIDGET = {
    RECEIVED: "#BFBFBF",
    PROCESSED: "#7F7F7F",
    COMPLETED: "#C00000",
};

export const HEADERWIDGETLEBEL = {
    RECEIVED: "Received",
    PROCESSED: "Processed",
    COMPLETED: "Completed",
};

export const MAINTABLEBEL = {
    HOME: "Home",
    WATCHLIST: "Watch List",
    LIVE: "Live",
    ERROR: "Error",
    FAVOURITES: "Favourites",
    CONFIGURATOR: "Preferences",
    SLA: "SLA",
    REPORTING: "Reporting",
    ADMIN: "Admin",
    REPORTS: "Records",
};

export const JOBSTATUSCOLOR = {
    GREY: "grey",
    GREEN: "green",
    ORANGE: "orange",
    RED: "red",
}

export const JOBSTATUSSTAGE = {
    RECEIVED: "R",
    PROCESSED: "P",
    COMPLETED: "C",
}

export const PARENTJOBSTATUSSTAGE = {
    RECEIVED: "R",
    PROCESSED: "P",
    COMPLETED: "C",
}

export const DEFAULTFILTER = {
    WATCHLIST: false,
    OTHERS: false,
}

export const REPORT_FILTER_CATEGORY = [
    { name: "ALL", key: 0 },
    { name: "BATCH", key: 1 },
    { name: "ADHOC", key: 2 },
];


export const REPORT_FILTER_TYPE = [
    { name: "DAY", key: 0 },
    { name: "MONTH", key: 1 },
    { name: "YEAR", key: 2 },
];